module.exports = "/_next/static/images/en-916e1b7cde7a3cef73952d31b7e3f985.svg";